export const webview = {
    webviewContent: 'Це зовнішня URL-адреса, і вона відкриється у новому вікні. Відкрити?',
    webviewButtonOpenTitle: 'Відкрити',
    webviewButtonCopyTitle: 'Скопіювати URL',
    webviewButtonOpenAgainTitle: 'Відкрити ще раз',
    notifications: {
      urlCopied: 'URL скопійовано!'
    }
  }